import { useEffect, useState } from "react";
import { Spinner } from "reactstrap";

import { useAuth } from "../../../../context/AuthContext";

import PrivateChatService from "../Services/PrivateChatService";
import PrivateChatHubService from "../Hub/PrivateChatHubService";

import PrivateMessageList from "../Components/PrivateMessageList";
import PrivateMessageInput from "../Components/PrivateMessageInput";
import TypingIndicator from "../Components/TypingIndicator";

import { PrivateMessage } from "../types/PrivateChat";

interface Props {
    conversationId: string;
    customerName: string;
}

const CoordinatorPrivateChat = ({
    conversationId,
    customerName
    
}: Props) => {

    const { token } = useAuth();

    const [loading, setLoading] = useState(true);

    const [messages, setMessages] =
        useState<PrivateMessage[]>([]);

    const [typing, setTyping] =
        useState(false);

    useEffect(() => {

        if (!conversationId)
            return;

        loadConversation();

        // eslint-disable-next-line
    }, [conversationId]);

    useEffect(() => {

        if (!token)
            return;

        connectHub();



        // eslint-disable-next-line
    }, []);

    const loadConversation = async () => {

        setLoading(true);

        try {

            const history =
                await PrivateChatService.getMessages(
                    conversationId
                );

            setMessages(history);

            await PrivateChatHubService.markRead(
                conversationId
            );

        }
        catch(error:any){
            console.log(error)
        }
        finally {

            setLoading(false);

        }

    };

    const connectHub = async () => {

        await PrivateChatHubService.start(token!);

         registerEvents();

    };

const registerEvents = () => {

    PrivateChatHubService.onReceiveMessage(
        (message: PrivateMessage) => {

            if (message.conversationId !== conversationId)
                return;

            setMessages(prev => {

                const exists = prev.some(
                    x => x.privateMessageId === message.privateMessageId
                );

                if (exists) {
                    return prev;
                }

                return [...prev, message];

            });

            PrivateChatHubService.markDelivered(
                message.privateMessageId
            );

        }
    );

    PrivateChatHubService.onUserTyping(() => {

        setTyping(true);

    });

    PrivateChatHubService.onUserStoppedTyping(() => {

        setTyping(false);

    });

    PrivateChatHubService.onMessagesRead(() => {

        setMessages(prev =>
            prev.map(x => ({
                ...x,
                isRead: true
            }))
        );

    });

    PrivateChatHubService.onMessageDelivered(
        (messageId: string) => {

            setMessages(prev =>
                prev.map(x =>
                    x.privateMessageId === messageId
                        ? {
                              ...x,
                              isDelivered: true
                          }
                        : x
                )
            );

        }
    );
};



    const sendMessage = async (
        text: string
    ) => {

        await PrivateChatHubService.sendMessage({

            conversationId,

            message: text,

            messageType: 0

        });

    };

    if (loading)
        return <Spinner />;

    return (
    <div
        className="d-flex flex-column border rounded bg-white"
        style={{
            height: "70vh",
            overflow: "hidden"
        }}
    >
        {/* Header */}
        <div className="border-bottom p-3">
            <h5 className="mb-0">{customerName}</h5>
            <small className="text-muted">
                Private Conversation
            </small>
        </div>

        {/* Messages */}
        <div
            className="flex-grow-1"
            style={{
                minHeight: 0,
                overflow: "hidden"
            }}
        >
            <PrivateMessageList
                messages={messages}
            />
        </div>

        <TypingIndicator
            typing={typing}
            userName={customerName}
        />

        {/* Input */}
        <div className="border-top p-2">
            <PrivateMessageInput
                onSend={sendMessage}
                onTyping={() =>
                    PrivateChatHubService.typing(conversationId)
                }
                onStopTyping={() =>
                    PrivateChatHubService.stopTyping(conversationId)
                }
            />
        </div>
    </div>
);

};

export default CoordinatorPrivateChat;